var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('campaign-target-profile-by-id',{attrs:{"show-campaign-lookup":true,"campaign-id":_vm.campaignId,"target-profiles-overview-url":"/target-profiles"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }